/**
 * Lists of Medicines for Brand Consideration (LMBC) and List of Excluded Medicinal Items (LEMI)
 * Extracted from health.gov.au
 */

export const LMBC_ACTIVE_INGREDIENTS = [
    'adrenaline', 'epinephrine',
    'beclometasone',
    'botulinum toxin',
    'budesonide + formoterol', 'budesonide + eformoterol',
    'buprenorphine',
    'carbamazepine',
    'ciclosporin',
    'fluticasone furoate',
    'fluticasone propionate',
    'hydromorphone',
    'incobotulinumtoxin',
    'insulin',
    'interferon beta-1a',
    'peginterferon',
    'ferric carboxymaltose', 'ferric derisomaltose', 'iron polymaltose', 'iron sucrose',
    'itraconazole',
    'lithium carbonate',
    'mesalazine',
    'methylphenidate',
    'methylprednisolone',
    'methylprednisolone aceponate',
    'misoprostol',
    'morphine',
    'paclitaxel',
    'somatropin',
    'tolvaptan',
    'trastuzumab'
];

export const LEMI_ACTIVE_INGREDIENTS = [
    'bandage', 'tape', 'dressing', 'glucose indicator', 'ketone indicator', // Various
    'vaccine', 'venom', 'allergen', 'allergenic', // Vaccines and extracts
    'carbomer', 'carmellose', 'dextran', 'hyaluronate', 'hypromellose', 'paraffin eye', 'perfluorohexyloctane', 'polyethylene glycol', 'polyvinyl alcohol', 'retinol palmitate', // Ocular
    'skin emollient', 'bath oil', 'sunscreen', 'coal tar', 'sebitar', 'pinetarsol', 'ionil', // Derm
    'carbamide peroxide', 'docusate sodium', // Auricular
    'zinc oxide', 'peru balsam', 'benzyl benzoate', 'sodium citrate dihydrate', 'acetic acid', // Haemorrhoids / Constipation
    // Nutritional products, vitamins, minerals, amino acid formulas heavily feature:
    'vitamin', 'mineral', 'trace element', 'amino acid', 'protein hydrolysate', 'glycomacropeptide', 'triglyceride', 
    'arginine', 'citrulline', 'isoleucine', 'tyrosine', 'valine' 
];

/**
 * Checks if a drug falls under the LMBC based on its name or active ingredients.
 * @param {Object} drug The drug object
 * @returns {Boolean}
 */
export function isLmbc(drug) {
    if (!drug) return false;
    
    let searchString = '';
    if (drug.full_name) searchString += drug.full_name.toLowerCase() + ' ';
    if (drug.name) searchString += drug.name.toLowerCase() + ' ';
    if (drug.active_ingredients) {
        if (Array.isArray(drug.active_ingredients)) {
            searchString += drug.active_ingredients.join(' ').toLowerCase();
        } else {
            searchString += drug.active_ingredients.toLowerCase();
        }
    }

    return LMBC_ACTIVE_INGREDIENTS.some(ingredient => searchString.includes(ingredient.toLowerCase()));
}

/**
 * Checks if a drug falls under the LEMI.
 * This includes medicines with 4 or more active ingredients, and specific categories.
 * @param {Object} drug The drug object
 * @returns {Boolean}
 */
export function isLemi(drug) {
    if (!drug) return false;

    // Rule 1: Custom/Free-text medications without a standard alias_id / PBS code are often exempt 
    // Wait, the specification says "Free-text prescriptions: Software must allow brand-only prescribing". 
    // This is handled if it's a custom medication.
    if (drug.is_custom || !drug.alias_id) {
        return true;
    }

    // Rule 2: 4 or more active ingredients
    if (drug.active_ingredients && Array.isArray(drug.active_ingredients) && drug.active_ingredients.length >= 4) {
        return true;
    }

    // Rule 3: Matches the hardcoded list
    let searchString = '';
    if (drug.full_name) searchString += drug.full_name.toLowerCase() + ' ';
    if (drug.name) searchString += drug.name.toLowerCase() + ' ';
    if (drug.active_ingredients) {
        if (Array.isArray(drug.active_ingredients)) {
            searchString += drug.active_ingredients.join(' ').toLowerCase();
        } else {
            searchString += drug.active_ingredients.toLowerCase();
        }
    }

    return LEMI_ACTIVE_INGREDIENTS.some(ingredient => searchString.includes(ingredient.toLowerCase()));
}
